/**
 * Screens that replaced a CrudManager editor but live on their own routes
 * register here: the key is the model name, the value builds the record's URL.
 * openEditor, generateModuleUrl and the store's createInstance all consult it,
 * so every editor-shaped navigation for that model lands on the real screen —
 * including 'external' recents stamps (see CrudManagerModuleName).
 *
 * Deliberately import-free: registrations run at module-evaluation time from
 * route files, which sit inside the router ↔ crud-utils import cycle. A
 * standalone module is always fully evaluated before either side needs it.
 */
const externalEditorRoutes = new Map<string, (id: string) => string>()

export const registerExternalEditorRoute = (modelName: string, buildUrl: (id: string) => string): void => {
  externalEditorRoutes.set(modelName, buildUrl)
}

export const externalEditorRouteFor = (modelName: string): ((id: string) => string) | undefined =>
  externalEditorRoutes.get(modelName)
